<template>
  <li>
    <drop
      class="drop border-bottom"
      style="height: 5px"
      :class="
        overElement == item.item.id
          ? 'text-success border-success'
          : 'border-white'
      "
      @drop="handleDropFolder(item.item.id, true, ...arguments)"
      @dragover="allowOnlyFolders(...arguments, item.item.id)"
      @dragleave="handleDragLeave()"
    >
    </drop>
    <drop
      class="drop list d-flex flex-row justify-content-between align-items-center border-bottom"
      :class="
        overElement == item.item.id + '_folder'
          ? 'text-success border-success'
          : 'border-white'
      "
      @drop="handleDrop(item.item.id, null, false, ...arguments)"
      @dragover="handleDragOver(...arguments, item.item.id + '_folder')"
      @dragleave="handleDragLeave()"
    >
      <div>
        <drag class="drag" :transfer-data="{ item: item.item, isForm: false }">
          <span class="level-title font-weight-bold">
            <i
              class="pr-2 fa"
              :class="
                'fa-' +
                  (childsOpen[item.item.id] ? 'chevron-down' : 'chevron-right')
              "
              aria-hidden="true"
              @click="openClose(item)"
            ></i
            >{{ item.item.name }}</span
          >
        </drag>
      </div>
      <div
        class="actions d-flex flex-row justify-content-between align-items-center"
      >
        <div>
          <i
            class="fa fa-plus text-success mr-2"
            @click="addItem(item.item.id)"
          ></i>
        </div>
        <div v-if="item.item.parentId">
          <i
            class="fa fa-close text-danger"
            @click="deleteItem(item.item.id)"
          ></i>
        </div>
      </div>
    </drop>
    <div v-if="childsOpen[item.item.id]">
      <ul class="treeview-ul">
        <eoc-sidebar-folder-crud-item
          v-for="(subItem, index) in item.subItems"
          :key="subItem.item.id"
          :item="subItem"
          :last="index == item.subItems.length - 1"
          @add-item="addItem($event.parentId)"
          @edit-item="editItem($event.data)"
          @delete-item="deleteItem($event.id)"
          @reload="reload"
        />
      </ul>
      <ul>
        <div v-for="(form, index) in item.item.items" :key="form.id">
          <drop
            style="height: 5px"
            class="drop list border-bottom"
            :class="
              overElement == form.id
                ? 'text-success border-success'
                : 'border-white'
            "
            @drop="handleDrop(form.menuId, form.id, true, ...arguments)"
            @dragover="allowOnlyForms(...arguments, form.id)"
            @dragleave="handleDragLeave()"
          >
          </drop>
          <drag class="drag" :transfer-data="{ item: form, isForm: true }">
            <i class="fa fa-file-text mr-2"></i>
            <span class="font-weight-light">{{ form.name }}</span>
          </drag>
          <drop
            v-if="index == item.item.items.length - 1"
            style="height: 5px"
            class="drop list border-bottom"
            :class="
              overElement == form.id + '_last'
                ? 'text-success border-success'
                : 'border-white'
            "
            @drop="handleDrop(form.menuId, form.id, false, ...arguments)"
            @dragover="allowOnlyForms(...arguments, form.id + '_last')"
            @dragleave="handleDragLeave()"
          >
          </drop>
        </div>
      </ul>
    </div>
    <drop
      v-if="last"
      class="drop border-bottom"
      style="height: 5px"
      :class="
        overElement == item.item.id + '_last'
          ? 'text-success border-success'
          : 'border-white'
      "
      @drop="handleDropFolder(item.item.id, false, ...arguments)"
      @dragover="allowOnlyFolders(...arguments, item.item.id + '_last')"
      @dragleave="handleDragLeave()"
    >
    </drop>
  </li>
</template>

<script>
import { Drag } from "vue-drag-drop";
import patientFolderServer from "../../server/menu";

export default {
  name: "EocSidebarFolderCrudItem",
  components: { Drag },
  props: ["item", "last"],
  data() {
    return {
      childsOpen: {},
      overElement: null
    };
  },
  methods: {
    addItem(parentId) {
      this.$emit("add-item", { parentId });
      this.childsOpen[parentId] = true;
    },
    editItem(data) {
      this.$emit("edit-item", { data });
    },
    deleteItem(id) {
      this.$emit("delete-item", { id });
    },
    openClose(item) {
      this.childsOpen[item.item.id] = !this.childsOpen[item.item.id];
      this.childsOpen = { ...this.childsOpen };
    },
    async handleDrop(menuId, menuItemId, above, data) {
      this.overElement = null;
      if (data.isForm) {
        await patientFolderServer.moveMenuItem({
          menuItem: data.item,
          menuId: menuId,
          menuItemId: menuItemId,
          above: above
        });
      } else {
        if (data.item.id != menuId) {
          data.item.parentId = menuId;
        }
        await patientFolderServer.update(data.item.id, data.item);
      }
      this.$emit("reload");
    },
    async handleDropFolder(toMenuId, above, data) {
      this.overElement = null;
      await patientFolderServer.moveMenu({
        fromMenuId: data.item.id,
        toMenuId: toMenuId,
        above: above
      });
      this.$emit("reload");
    },
    allowOnlyForms(data, event, elemId) {
      if (!data.isForm) {
        event.dataTransfer.dropEffect = "none";
        this.overElement = null;
      } else {
        this.overElement = elemId;
      }
    },
    allowOnlyFolders(data, event, elemId) {
      if (data.isForm) {
        event.dataTransfer.dropEffect = "none";
        this.overElement = null;
      } else {
        this.overElement = elemId;
      }
    },
    handleDragOver(data, event, elemId) {
      this.overElement = elemId;
    },
    handleDragLeave() {
      this.overElement = false;
    },
    reload() {
      this.$emit("reload");
    }
  }
};
</script>

<style scoped>
i {
  cursor: pointer;
}

ul {
  list-style-type: none;
}
</style>
